const Priority = {
  High: 'High',
  Low: 'Low',
  Normal: 'Normal',
};

export default Priority;
